import { addModal } from 'weblite-web-modal-viewer'
import { SendInviteLinkDialog } from './send-invite-link'

const COMPONENT_ID = 'sendInviteLink'

export const showSendInviteLinkDialog = (
  props: Parameters<typeof SendInviteLinkDialog>[0],
) => addModal({ id: COMPONENT_ID, props })

export default {
  [COMPONENT_ID]: {
    Component: SendInviteLinkDialog,
  },
}
